import { partnerPromoCodes } from "@/core/data";

const isBrandingPartner = (promoCode: string): boolean => {
  const allowedPartnedPromoCodes: string[] = Object.keys(partnerPromoCodes);
  return allowedPartnedPromoCodes.includes(promoCode);
};

export default isBrandingPartner;
